var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNote = function SvgIconNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.125a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zM9 12.875a1 1 0 1 0 0 2h1.875a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m21.175 14.764.075-.075V4.5a1.75 1.75 0 0 0-1.75-1.75h-15A1.75 1.75 0 0 0 2.75 4.5v15a1.75 1.75 0 0 0 1.75 1.75h10.19l.074-.075a1 1 0 0 0 .851-.851l4.709-4.709a1 1 0 0 0 .85-.85M4.75 4.75v14.5h8.875v-4.625a1 1 0 0 1 1-1h4.625V4.75zm13.46 10.875h-2.585v2.586z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconNote;